export const ORDER_STATUS = {
  NOT_ASSIGNED: "NOT_ASSIGNED",
  NOT_ACCEPTED: "NOT_ACCEPTED",
  NOT_STARTED_YET: "NOT_STARTED_YET",
  STARTED: "STARTED",
  PICKED_UP: "PICKED_UP",
  ON_THE_WAY: "ON_THE_WAY",
  READY_TO_DELIVER: "READY_TO_DELIVER",
  ALREADY_DELIVERED: "ALREADY_DELIVERED",
  INCOMPLETE: "INCOMPLETE",
  FAILED_DELIVERY: "FAILED_DELIVERY",
  BROADCASTED: "BROADCASTED",
  PRE_ASSIGNED: "PRE_ASSIGNED",
  CANCELLED: "CANCELLED"
}

export const getOrderStatusDisplayText = (status) => {
  switch (status) {
    case ORDER_STATUS.NOT_ASSIGNED:
      return "Not Assigned";
    case ORDER_STATUS.NOT_ACCEPTED:
      return "Not Accepted";
    case ORDER_STATUS.NOT_STARTED_YET:
      return "Not Started Yet";
    case ORDER_STATUS.STARTED:
      return "Started";
    case ORDER_STATUS.PICKED_UP:
      return "Picked Up";
    case ORDER_STATUS.ON_THE_WAY:
      return "On the Way";
    case ORDER_STATUS.READY_TO_DELIVER:
      return "Ready to Deliver";
    case ORDER_STATUS.ALREADY_DELIVERED:
      return "Already Delivered";
    case ORDER_STATUS.INCOMPLETE:
      return "Incomplete";
    case ORDER_STATUS.FAILED_DELIVERY:
      return "Failed Delivery";
    case ORDER_STATUS.BROADCASTED:
      return "Broadcasted";
    case ORDER_STATUS.PRE_ASSIGNED:
      return "Pre-Assigned";
    case ORDER_STATUS.CANCELLED:
      return "Cancelled";
    default:
      return "Unknown";
  }
}

export const isOrderAcceptedOrLater = (status) => {
  if (!status) return false;
  
  // Orders that are NOT accepted or later
  const notAcceptedStatuses = [
    ORDER_STATUS.NOT_ASSIGNED,
    ORDER_STATUS.NOT_ACCEPTED,
    ORDER_STATUS.BROADCASTED,
    ORDER_STATUS.PRE_ASSIGNED,
    ORDER_STATUS.CANCELLED
  ];
  
  return !notAcceptedStatuses.includes(status);
}
